import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    document.title = "The Owen Lab";

    const favicon = document.getElementById("dynamic-favicon");
    if (favicon) {
      favicon.setAttribute("href", "/western-favicon.png");
    }
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      {/* Main Navigation */}
      {/* <header className="w-full bg-white shadow-md border-b-[12px] border-primary sticky top-0 z-50"> */}
      <header className="w-full bg-white shadow-md sticky top-0 z-50">
        {/* <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center"> */}
        {/* <div className="w-full flex justify-between items-center px-6 py-4"> */}
        <div className="w-full flex justify-between items-center px-6 md:px-4 lg:px-6 py-4">
          {/* Logo */}
          <NavLink
            to="/"
            // className="text-3xl font-lato text-primary tracking-wide hover:opacity-90 transition"
            className="text-2xl md:text-3xl font-lato text-primary tracking-wide hover:opacity-90 transition whitespace-nowrap"
          >
            The Owen Lab
          </NavLink>

          {/* Desktop Navigation */}
          {/* <nav className="hidden md:flex space-x-8 items-center"> */}
          {/* <nav className="hidden md:flex items-center space-x-4 lg:space-x-8 text-sm md:text-base lg:text-lg"> */}
          {/* <nav className="hidden md:flex items-center whitespace-nowrap space-x-1 md:space-x-2 lg:space-x-6 text-xs md:text-sm lg:text-base"> */}
          {/* <nav className="hidden md:flex items-center ml-auto space-x-4 lg:space-x-8 text-xs md:text-sm lg:text-base whitespace-nowrap"> */}
          <nav className="hidden md:flex items-center ml-auto space-x-2 xl:space-x-8 text-xs md:text-sm xl:text-base whitespace-nowrap">
            {[
              "Research",
              "Publications",
              "Media",
              "Our Team",
              "Contact Us",
              "Opportunities",
              "Books",
            ].map((item, index) => (
              <NavLink
                key={item}
                // to={`/${item.replace(/ /g, "")}`}
                to={item === "Books" ? "/books" : `/${item.replace(/ /g, "")}`}
                //     className={({ isActive }) =>
                //       isActive
                //         // ? "text-lg font-lato text-secondary relative inline-block after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-secondary"
                //         // : "text-lg font-lato text-gray-700 hover:text-primary transition duration-300 hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:w-full hover:after:h-[2px] hover:after:bg-primary"
                //         ? "text-lg font-lato text-secondary relative inline-block after:absolute after:bottom-0 after:left-0 after:w-auto after:h-[2px] after:bg-secondary"
                // : "text-lg font-lato text-gray-700 hover:text-primary transition duration-300 inline-block hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:w-auto hover:after:h-[2px] hover:after:bg-primary"
                //     }
                className={({ isActive }) =>
                  `${isActive ? "text-secondary" : "text-gray-700 hover:text-primary"}
   whitespace-nowrap px-1 py-1 transition`
                }
              >
                {item.replace(/([A-Z])/g, " $1").trim()}
                {/* {index < 5 && < span className="border-r-2 border-primary mx-4"></span>} */}
                {/* {index < 5 && (<span className="border-r border-primary mx-1 md:mx-2 lg:,x-4"></span>)} */}
                {/* {index < 5 && (<span className="border-r border-primary mx-1 md:mx-1 lg:mx-4"></span>)} */}
                {index < 6 && (
                  <span className="border-r border-primary mx-1 md:mx-1 lg:mx-4"></span>
                )}
              </NavLink>
            ))}

            {/* {isAuthenticated ? (
              <>
                <NavLink
                  to="/admin"
                  className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
                >
                  Admin Panel
                </NavLink>
                <button
                  onClick={handleLogout}
                  className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
                >
                  Logout
                </button>
              </>
            ) : (
              <NavLink
                to="/admin/login"
                className="text-lg font-medium text-gray-700 hover:text-primary transition duration-300"
              >
                Login
              </NavLink>
            )} */}

            {/* Conditionally Render Admin Panel, Login and Logout buttons */}
            {/* {isAdminPage && isAuthenticated ? (
              <>
                <NavLink
                  to="/admin"
                  className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
                >
                  Admin Panel
                </NavLink>
                <button
                  onClick={handleLogout}
                  className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
                >
                  Logout
                </button>
              </>
            ) : isAdminPage ? (
              <NavLink
                to="/admin/login"
                className="text-lg font-medium text-gray-700 hover:text-primary transition duration-300"
              >
                Login
              </NavLink>
            ) : null}
          </nav> */}

            {/* Show Logout only if authenticated */}
            {isAuthenticated && isAdminPage && (
              <button
                onClick={handleLogout}
                className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
              >
                Logout
              </button>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-primary focus:outline-none"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            {isMenuOpen ? "✖" : "☰"}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white shadow-lg border-t border-gray-200 py-4 px-6">
            <nav className="flex flex-col space-y-4">
              {[
                "Research",
                "Publications",
                "Media",
                "Our Team",
                "Contact Us",
                "Opportunities",
                "Books",
              ].map((item) => (
                <NavLink
                  key={item}
                  // to={`/${item.replace(/ /g, "")}`}
                  to={
                    item === "Books" ? "/books" : `/${item.replace(/ /g, "")}`
                  }
                  className={({ isActive }) =>
                    isActive
                      ? "text-lg font-semibold text-secondary relative after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-secondary"
                      : "text-lg font-medium text-gray-700 hover:text-primary transition duration-300 hover:after:absolute hover:after:bottom-0 hover:after:left-0 hover:after:w-full hover:after:h-[2px] hover:after:bg-primary"
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.replace(/([A-Z])/g, " $1").trim()}
                </NavLink>
              ))}

              {/* {isAuthenticated ? (
                <>
                  
                  <button
                    onClick={handleLogout}
                    className="text-lg font-medium text-gray-700 hover:text-red-600 transition duration-300"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <NavLink
                  to="/admin/login"
                  className="text-lg font-medium text-gray-700 hover:text-accent transition duration-300"
                >
                  Login
                </NavLink>
              )} */}
            </nav>
          </div>
        )}
        {/* <div className="w-full h-[12px] bg-gradient-to-r from-[#003366] to-[#006d66]"></div> */}
      </header>
    </>
  );
}

export default Navbar;
